{
    "navigation-compact": "32em",
    "navigation-search-icon": "37.5em",
    "navigation-project-label": "56em",
    "navigation-action-labels": "68em",
    "content-header-compact": "40em"
}
